module.exports = __webpack_public_path__ + "static/assets/3e1b6578ea2b89e09265a3b0285fffa9.png";